import '@mantine/core/styles.css';
import './App.css';
import Signup from './Auth/Signup';
import { Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import { useEffect } from 'react';
import { useAuthContext } from './Hooks/UseAuthContext';
import Admin from './Admin/Admin';
import Adminsignup from './Admin/Adminsignup';

function App() {


  const { dispatch } = useAuthContext();

  useEffect(() => {
    const checkTokenExpiry = () => {

      const expiryTime = localStorage.getItem("expiryTime");

      // =====================================
      // NO TOKEN
      // =====================================

      if (!expiryTime) return;

      const currentTime = Date.now();

      // =====================================
      // TOKEN EXPIRED
      // =====================================

      if (currentTime >= Number(expiryTime)) {

        localStorage.removeItem("user");

        localStorage.removeItem("expiryTime");

        dispatch({ type: "LOGOUT" });

        window.location.href = "/";
      }

      // =====================================
      // CURRENT PATH
      // =====================================

      const currentPath = window.location.pathname;

      // =====================================
      // ALLOWED ROUTES
      // =====================================

      const allowedRoutes = [
        "/home",
        "/admin",
        "/admin/login"
      ];

      // =====================================
      // REDIRECT ONLY IF ROUTE INVALID
      // =====================================

      if (!allowedRoutes.includes(currentPath)) {
        window.location.href = "/home";
      }
    };

    // 1. Check immediately on mount
    checkTokenExpiry();

    // 2. Then keep checking every 10 seconds in real-time
    const interval = setInterval(checkTokenExpiry, 10 * 1000);

    // 3. Cleanup interval on unmount
    return () => clearInterval(interval);

  }, [dispatch]); // Remove 'user' from deps to avoid re-running on every auth change

  return (
    <>
      <Routes>
        <Route path='/' element={<Signup />} />
        <Route path='/home' element={<Home />} />
        <Route path="/admin/login" element={<Adminsignup />} />
        <Route path='/admin' element={<Admin />} />
      </Routes>

    </>
  );
}

export default App;
